import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useSuppliersList() {
  // Use toast
  const toast = useToast();

  const refSupplierListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "user_number", label: "編號", sortable: true, class: 'sticky-column' },
    // { key: "type", label: "類別" },
    { key: "name_cn", label: "供應商名稱（中文）", class: 'sticky-column' },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "name", label: "系統帳號名稱" },
    { key: "locked", label: "封鎖"},
    { key: "is_active", label: "狀態" },
    { key: "address", label: "地址", sortable: true },
    { key: "company_name_cn", label: "聯絡人姓名（中文）" },
    { key: "company_name_en", label: "聯絡人姓名（英文）" },
    { key: "phone", label: "聯絡電話" },
    { key: "email", label: "電郵地址"},
    { key: "bank", label: "銀行名稱", sortable: true },
    { key: "bank_account", label: "銀行號碼", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refSupplierListTable.value
      ? refSupplierListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refSupplierListTable.value.refresh();
    // fetchSuppliers()
  };

  const suppliersList = ref(null);
  const filter_gender_id = ref(null);
  const filter_bank_id = ref(null);
  const filter_payment_method_id = ref(null);
  const filter_is_active = ref(null);


  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchSuppliers = (ctx, callback) => {
    store
      .dispatch("supplier/fetchSuppliers", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        gender_id: filter_gender_id.value,
        bank_id: filter_bank_id.value,
        payment_method_id: filter_payment_method_id.value,
        is_active: filter_is_active.value,
      })
      .then((response) => {
        const { entities, total } = response.data;
        callback(entities);
        totalRow.value = total;
        suppliersList.value = entities
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };


  return {
    fetchSuppliers,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    suppliersList,
    refSupplierListTable,
    ability,
    refetchData,
  };
}
